import { Routes } from '@angular/router';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';

import { authGuard, anonymousGuard } from './auth-core/guards/auth.guard';
import { tenantsFeature } from './features/tenants/store/tenants.feature';
import { TenantsEffects } from './features/tenants/store/tenants.effects';

/**
 * Two top-level states, two top-level routes through the root outlet:
 *  - `/auth`  the login screen (auth state)
 *  - `''`     the Material sidenav shell with feature children (main state)
 * Each is tagged with `animation` data to drive the directional slide.
 */
export const routes: Routes = [
  {
    path: 'auth',
    canActivate: [anonymousGuard],
    data: { animation: 'auth' },
    loadComponent: () => import('./layout/auth/auth').then((m) => m.Auth),
  },
  {
    path: '',
    canActivate: [authGuard],
    data: { animation: 'main' },
    loadComponent: () => import('./layout/main-shell/main-shell').then((m) => m.MainShell),
    children: [
      {
        path: '',
        loadComponent: () => import('./features/home/home').then((m) => m.Home),
      },
      {
        path: 'tenants',
        // Feature-local NgRx slice + effects, registered lazily with the route.
        providers: [provideState(tenantsFeature), provideEffects(TenantsEffects)],
        loadComponent: () => import('./features/tenants/tenants').then((m) => m.Tenants),
      },
      {
        path: 'account',
        loadComponent: () => import('./features/account/account').then((m) => m.Account),
      },
      { path: '**', redirectTo: '' },
    ],
  },
  { path: '**', redirectTo: '' },
];

